import { createApp } from 'vue'
import { createPinia } from 'pinia'
import { createRouter, createWebHistory } from 'vue-router'
import App from './App.vue'
import './style.css'

import AuthView from './views/AuthView.vue'
import GameLayout from './views/GameLayout.vue'
import DashboardView from './views/DashboardView.vue'
import IdolsView from './views/IdolsView.vue'
import ShowsView from './views/ShowsView.vue'
import SettingsView from './views/SettingsView.vue'

const router = createRouter({
  history: createWebHistory(),
  routes: [
    { path: '/', redirect: '/auth' },
    { path: '/auth', component: AuthView },
    {
      path: '/game',
      component: GameLayout,
      children: [
        { path: '', redirect: '/game/dashboard' },
        { path: 'dashboard', component: DashboardView },
        { path: 'idols', component: IdolsView },
        { path: 'shows', component: ShowsView },
        { path: 'settings', component: SettingsView },
      ],
    },
  ],
})

const pinia = createPinia()
const app = createApp(App)
app.use(pinia)
app.use(router)
app.mount('#app')
